import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { apiErr } from "@/lib/api";
import { Seo } from "@/components/Seo";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(email, password);
      toast.success("Welcome back");
      navigate(user.role === "admin" ? "/admin" : "/");
    } catch (err) {
      toast.error(apiErr(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <div className="flex min-h-[80vh] items-center justify-center px-5" data-testid="login-page">
      <Seo title="Log In — The Hoodie Project®" />
      <div className="w-full max-w-md border border-border p-8 md:p-10">
        <h1 className="font-display text-4xl font-extrabold tracking-tighter">LOG IN</h1>
        <p className="mt-2 text-sm text-muted-foreground">Access your storefront, orders and drops.</p>
        <form onSubmit={submit} className="mt-8 space-y-4">
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" data-testid="login-email"
            className="w-full border border-border bg-black px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-white" />
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" data-testid="login-password"
            className="w-full border border-border bg-black px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-white" />
          <button type="submit" disabled={loading} data-testid="login-submit"
            className="w-full bg-white py-4 text-xs font-bold tracking-[0.3em] text-black transition-colors hover:bg-neutral-300 disabled:opacity-50">
            {loading ? "…" : "LOG IN"}
          </button>
        </form>
        <p className="mt-6 text-sm text-muted-foreground">No account? <Link to="/register" className="text-white underline">Sign up</Link></p>
      </div>
    </div>
  );
}
